import mask from 'slim-mask-js'

export default function animalUid(str = '') {
  return mask(str, '####.####.####.####.####')
}
